import { render, staticRenderFns } from "./register.vue?vue&type=template&id=bbc32ba8&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=bbc32ba8&prod&scoped=true&lang=scss"
import style1 from "./register.vue?vue&type=style&index=1&id=bbc32ba8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc32ba8",
  null
  
)

export default component.exports